function normalizeRoleLabel(roleLabel = "") {
  let label = String(roleLabel || "").trim();

  // Remove slot numbering
  label = label.replace(/\s*\d+$/, "");

  // Remove "- Slot X"
  label = label.replace(/\s*-\s*Slot\s*\d+$/i, "");

  return label;
}

export function isBikeSlot(roleLabel) {
  const base = normalizeRoleLabel(roleLabel);
  return /^Bike$/i.test(base);
}

export function isCartSlot(roleLabel) {
  const base = normalizeRoleLabel(roleLabel);
  return /^Cart$/i.test(base);
}

export function isTentSlot(roleLabel) {
  const base = normalizeRoleLabel(roleLabel);
  return /^Tent\s+\d+$/i.test(roleLabel); // keep original for tent number
}

export function isOpsSupervisor(roleLabel) {
  return /^Ops Supervisor\s+\d+$/i.test(String(roleLabel || "").trim());
}

export function isAmbulanceSlot(roleLabel) {
  const base = normalizeRoleLabel(roleLabel);
  return /^Ambulance/i.test(base);
}

export function isDispatcherSlot(roleLabel) {
  const base = normalizeRoleLabel(roleLabel);
  return base === "Dispatcher";
}

export function isFixedTwoPeople(roleLabel) {
  return isBikeSlot(roleLabel) || isCartSlot(roleLabel) || isDispatcherSlot(roleLabel);
}

export function isUnlimitedPeopleSlot() {
  return false;
}

export function isFrontOrBackNine(blockTitle) {
  return blockTitle === "Front 9" || blockTitle === "Back 9";
}

export function canHaveInsideExtras(roleLabel) {
  return isTentSlot(roleLabel) || isOpsSupervisor(roleLabel);
}

export function getAddTargetsForBlock(blockTitle, front9Assignments = [], back9Assignments = []) {
  if (blockTitle === "Front 9") {
    return front9Assignments.filter((role) => isTentSlot(role) || isOpsSupervisor(role));
  }

  if (blockTitle === "Back 9") {
    return back9Assignments.filter((role) => isTentSlot(role) || isOpsSupervisor(role));
  }

  return [];
}

// 🔑 EXPORT THIS
export function getBaseRoleLabel(roleLabel = "") {
  return normalizeRoleLabel(roleLabel);
}